// TODO: Data Converter 관련 함수들 모음
import type { CurriculumConceptTreeNode } from '@mathflat/domain/Curriculum'

import type { CurriculumTreeNode } from '@/dto'

class DataConvertService {
  // private memberToNodeData(member: StudentGroup['memberList'][number]): DataNode {
  //   return {
  //     key: member.id,
  //     title: member.name,
  //
  //   }
  // }
  // toAssignStudentTree(studentGroupByLessonColl: StudentGroupCollection) {
  //   const gradeTreeData: DataNode[] = [...studentGroupByLessonColl.studentByGrade.values()].map((data) => {
  //     return {
  //       key: data.groupId,
  //       title: data.groupName,
  //       children: data.memberList.map(this.memberToNodeData)
  //     }
  //   })
  //   const classGroupBy = groupBy(lessonClassColl.toArr, (lessonClass) => lessonClass.)
  // }
  // 단원 유형별 -> 트리 NodeData
  curriculumToTreeData(data: CurriculumConceptTreeNode[]) {
    const map = new Map<string, CurriculumConceptTreeNode>()

    // 재귀
    const recursive = (data: CurriculumConceptTreeNode[], depth = 0): CurriculumTreeNode[] =>
      data.map((d) => {
        // 대단원, 중단원, 소단원, 개념 id를 하나의 Map에서 관리하기 때문에 중복 발생
        // 중복 방지 및 유일값 보장을 위해 trieKey 정보 추가
        const uniqueId = `${d.trieKey}_${d.id}`

        map.set(uniqueId, d)
        const isOnlyConcept = d.relationList.length === 0 && d.conceptList.length > 0
        return {
          key: d.id,
          title: d.name,
          children: isOnlyConcept
            ? recursive(
                d.conceptList.map((concept) => ({
                  ...concept,
                  hidden: false,
                  relationList: [],
                  includedRelationIdList: [],
                  includedConceptIdList: [concept.id],
                  conceptList: [],
                  trieKey: d.trieKey,
                })),
                depth + 1,
              )
            : recursive(
                d.relationList.map((relation) => ({
                  ...relation,
                  trieKey: d.trieKey,
                })),
                depth + 1,
              ),
          depth,
          trieKey: d.trieKey ?? '',
        }
      })

    return {
      treeNode: recursive(data),
      dataMap: map,
    }
  }
}

const dataConvertService = new DataConvertService()

export default dataConvertService
